export default "__VITE_ASSET__CrWrZw3i__"